<template>
  <div v-if="playerData" :class="$style.wrapper">
    <div :class="$style.menu">
      <div
        v-for="(tab, index) in tabs"
        :class="[$style.tab, { [$style.active]: tab === selectedTab }]"
        :key="`${hero.name}-${index}`"
        @click="toggleHeroMenu(tab)"
      >
        {{ tab }}
      </div>
    </div>
    <div :class="$style.container">
      <hero-abilities
        :heroName="playerData.hero.name"
        :abilities="playerData.abilities"
        :aghanims="aghanimsStatus"
        v-if="selectedTab === 'Abilities'"
      />
      <player-stats v-if="selectedTab === 'Stats'" :stats="playerData.stats" />
      <hero-inventory v-if="selectedTab === 'Inventory'" />
      <hero-aghanims :hero="playerData.hero" v-if="selectedTab === 'Aghanim\'s'" />
      <hero-talents :hero="playerData.hero" position="top" v-if="selectedTab === 'Talents'" />
      <hero-innate :hero="playerData.hero.name" v-if="selectedTab === 'Innate'" />
    </div>
  </div>
</template>

<script>
import PlayerStats from './stats.vue'
import HeroAbilities from './abilities.vue'
import HeroAghanims from './aghanims.vue'
import HeroTalents from './talents.vue'
import HeroInventory from './inventory.vue'
import HeroInnate from './innate.vue'

export default {
  name: 'hero-menu',
  props: ['hero'],
  components: {
    PlayerStats,
    HeroAbilities,
    HeroAghanims,
    HeroTalents,
    HeroInventory,
    HeroInnate
  },
  computed: {
    playerData() {
      return this.$store.getters.playerData
    },
    heroDetails() {
      return this.getHeroDetails(this.hero.name)
    },
    selectedTab() {
      return this.$store.getters.selectedHeroTab
    },
    aghanimsStatus() {
      return {
        scepter: this.playerData.hero.aghanims_scepter,
        shard: this.playerData.hero.aghanims_shard
      }
    },
    tabs() {
      return ['Stats', 'Abilities', 'Innate', "Aghanim's", 'Talents', 'Inventory']
    }
  },
  methods: {
    toggleHeroMenu(btnIndex) {
      if (btnIndex !== this.$store.getters.selectedHeroTab) {
        this.$store.commit('SetSelectedHeroTab', btnIndex)
      }
    }
  }
}
</script>

<style lang="scss" module>
.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  box-shadow: inset 0 2vw 10vw rgba(black, 0.6);
  background-color: #236088;
}

.menu {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 1vw;
  padding: 2vw 1vw;
}

.tab {
  color: #515557;
  background: rgba(black, 0.8);
  border-radius: 2vw;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 4vw;
  padding: 2vw 4vw;
  cursor: pointer;
  border: 0.5vw solid black;

  &.active {
    color: var(--color_primary);
    border: 0.5vw solid var(--color_primary);
  }
}

.container {
  min-height: 20vw;
  width: 100%;
  padding: 2vw 4vw 5vw 4vw;
}
</style>
